import { useMemo } from 'react';
import axios, { AxiosResponse } from 'axios';
import { useQuery } from '@tanstack/react-query';

import { extractAccessToken } from '../helpers/decodeLocalStorage';
import { ResponseList } from '../models/Response';
import { AdminDetail } from '../models/admin/MasterAdmin';

export function useAdminDetails() {
    const citizenId = useMemo(() => {
        const payload = extractAccessToken();
        return payload.citizen_id ?? payload.username;
    }, []);

    return useQuery({
        enabled: !!citizenId,
        queryKey: ['admin-details', citizenId],
        queryFn: ({ signal }) =>
            axios.get<ResponseList<AdminDetail>>('/v2/configuration/admin', {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        'WF_APPLICATION'
                    )}`
                },
                params: {
                    citizen_id: citizenId
                }
            }),
        select: (response: AxiosResponse<ResponseList<AdminDetail>>) =>
            response.data.result_list,
        retry: 1
    });
}
